import { FeatureParams } from "../../api/services/client/models";
import { hasKey } from "../../helpers/utils";
import { FeaturesCheckBoxes } from "./createGenericAccount/modelsAndSchemas/Models";

export const getMappedFeatures = (features: FeaturesCheckBoxes[]) => {
  const updatedFeatures = features
    ?.filter((item: FeaturesCheckBoxes) => item.isChecked)
    .map((item: FeaturesCheckBoxes) => {
      const result: FeatureParams = { id: item.id };
      if (hasKey(item, "type")) {
        result.type = item.type;
      }
      return result;
    });
  return updatedFeatures;
};
